<template>
  <div class="set-end-divider flex items-center gap-3 py-3 my-1">
    <div class="set-end-line flex-1 h-px"></div>
    <span
      class="text-xs font-semibold uppercase tracking-wider whitespace-nowrap px-3 text-teal-400"
    >
      {{ label }}
    </span>
    <div class="set-end-line flex-1 h-px"></div>
  </div>
</template>

<script setup>
defineProps({
  label: {
    type: String,
    default: "Set end"
  }
});
</script>

<style scoped>
.set-end-line {
  border-top: 1px solid;
  border-color: rgb(45 212 191); /* teal-400 */
  box-shadow: 0px 0px 8px 3px rgba(45, 212, 191, 0.5);
}
</style>
